var _ = require("underscore");
var lib_core = require("lib-core");

var InspectorInputType = {
    IMAGE               : 'image',
    SELECTABLE_IMAGE_GROUP: 'selectable_image_group',
    TEXT                : 'text',
    READ_ONLY           : 'read_only',
    VALUE_AND_UNIT      : 'value_and_unit',
    VALUE_UNIT_CHECK    : 'value_unit_check',
    VALUE_AND_FIXEDUNIT : 'value_and_fixedunit',
    CHECKBOX            : 'checkbox',
    SELECTBOX           : 'selectbox',
    SELECTBOXEVENT      : 'selectboxevent',
    BUTTON              : 'button',
    BUTTON_GROUP        : 'button_group',
    SLIDER              : 'slider',
    SPINNER             : 'spinner',
    COMMON_CONTROLS     : 'common_controls',
    COMMON_CONTROLS_BUTTON : 'common_controls_button',
    COLORPICKER         : 'colorpicker',
    SKETCH2D            : 'sketch2d',
    FILE                : 'file',
    LABEL               : 'label',
    ROW                 : 'row'
};



/*
!! required and optional fields are inherited
 */

/*********************************** AbstractInspectorElement ************************************/
/*
required fields:
label
optional fields:
non_combinable: do not combine with other inspector elements when selecting multiple objects
read_only: only show values, do not apply changes
visible: show or hide the inspector element. can be a versions.value.
disabled: field is disabled
*/
var AbstractInspectorElement = function(object) {
    this.makeObservableTreeNode();  // TODO: is this an observable treenode? or are observable collection sufficient
    _.extend(this, object);
    if(!this.visible) {
        this.visible = this.value("visible", true);
        this.visible(true);
    }
    var self = this;
    // _.each(object, function(v,n) {
    //     console.assert(self.attributes.indexOf(n) != -1);
    // });
    _.each(self.attributes, function(n) {
        if(!(self.disabled && n === 'datamember')) { //datamember is not applicable for disabled field
            console.assert(self[n] != undefined, n + " is undefined");
        }
    });
    self.times_combined = 1;
};
lib_core.mixin(AbstractInspectorElement, lib_core.ObservableTreeNode);
AbstractInspectorElement.prototype.attributes = ["label"];

AbstractInspectorElement.prototype.combineWith = function(other) {
    if(this.non_combinable || other.non_combinable) return false;
    if(this.label != other.label) return false;
    this.visibles = [].concat(this.visibles || this.visible, other.visibles || other.visible);
    this.visible = null;
    this.times_combined += 1;
    return true;
};

AbstractInspectorElement.prototype.createValueSpreader = function(key, valuemembers, mixed_val) {
    var self = this;
    console.assert(key);
    console.assert(valuemembers);
    mixed_val = mixed_val || "";
    var triggers = valuemembers;
    var spreader = self.shadow("spreader_"+key,
        function() {
            var allSame = true;
            var value = valuemembers[0]();
            $.each(valuemembers, function(index, dm) {
                allSame = allSame && dm() === value;
            });
            if(allSame)
                return value;
            else
                return mixed_val;
        },
        function(val) {
            var success = true;
            $.each(valuemembers, function(index, dm) {
                success = dm(val) && success;
            });
            return success;
        },
        triggers
    );
    return spreader;
};

AbstractInspectorElement.prototype.finishCombination = function() {
    if(this.times_combined == 1) return;
    this.visible = this.createValueSpreader("visible", this.visibles, this.visible_if_any);
};

/*********************************** RowInspectorElement ************************************/
var RowInspectorElement = function(object) {
    AbstractInspectorElement.call(this, object);
};
lib_core.inherit(RowInspectorElement, AbstractInspectorElement);
lib_core.JsonParser.registerClass(RowInspectorElement, "RowInspectorElement");

/*********************************** ImageInspectorElement ************************************/
/*
required fields:
image
*/
var ImageInspectorElement = function(object) {
    this.attributes.splice(this.attributes.indexOf("label"), 1);

    AbstractInspectorElement.call(this, object);
    console.assert(object.image !== undefined, "no image found for inspector image element");
};

lib_core.inherit(ImageInspectorElement, AbstractInspectorElement);
lib_core.JsonParser.registerClass(ImageInspectorElement, "ImageInspectorElement");
ImageInspectorElement.prototype.attributes = AbstractInspectorElement.prototype.attributes.concat(["image"]);

ImageInspectorElement.prototype.combineWith = function(other) {
    if(this.image != other.image) return false;
    return AbstractInspectorElement.prototype.combineWith.call(this, other);
};

/*********************************** SelectableImageGroupInspectorElement ************************************/

var SelectableImageGroupInspectorElement = function(object) {
    AbstractInspectorElement.call(this, object);
    this.images = _.map(this.images, function(image) {
        return new ImageInspectorElement(image);
    });
};
lib_core.inherit(SelectableImageGroupInspectorElement, AbstractInspectorElement);
lib_core.JsonParser.registerClass(SelectableImageGroupInspectorElement, "SelectableImageGroupInspectorElement");
SelectableImageGroupInspectorElement.prototype.attributes = AbstractInspectorElement.prototype.attributes.concat(["images"]);

SelectableImageGroupInspectorElement.prototype.combineWith = function(other) {
    if(this.images.length != other.images.length) return false;
    var combined = true;
    _.each(this.images, function(image) {
        _.each(other.images, function(other_image) {
            combined = combined && image.combineWith(other_image);
        });
    });
    if(!combined) return false;
    return AbstractInspectorElement.prototype.combineWith.call(this, other);
};

SelectableImageGroupInspectorElement.prototype.finishCombination = function() {
    AbstractInspectorElement.prototype.finishCombination.call(this);
    _.each(this.images, function(image) {
        image.finishCombination();
    });
};

/*********************************** TextInspectorElement ************************************/
/*
required fields:
datamember
optional fields:
datatype: e.g. lib_core.types.float
update_while_typing: update the datamodel while typing in the inspector
 */
var TextInspectorElement = function(object) {
    AbstractInspectorElement.call(this, object);
};
lib_core.inherit(TextInspectorElement, AbstractInspectorElement);
lib_core.JsonParser.registerClass(TextInspectorElement, "TextInspectorElement");
TextInspectorElement.prototype.attributes = AbstractInspectorElement.prototype.attributes.concat(["datamember"]);

TextInspectorElement.prototype.combineWith = function(other) {
    if(this.update_while_typing != other.update_while_typing) return false;
    if(this.read_only != other.read_only) return false;
    if(this.datatype != other.datatype) return false;
    if(this.disabled != other.disabled) return false;
    this.datamembers = [].concat(this.datamembers || this.datamember, other.datamembers || other.datamember);
    this.datamember = null;
    return AbstractInspectorElement.prototype.combineWith.call(this, other);
};

TextInspectorElement.prototype.finishCombination = function() {
    AbstractInspectorElement.prototype.finishCombination.call(this);
    if(this.times_combined == 1) return;
    this.datamember = this.createValueSpreader("datamember", this.datamembers);
};


/*********************************** ValueUnitInspectorElement ************************************/
/*
required fields:
unit_member
allowed_units
*/
var ValueUnitInspectorElement = function(object) {
    TextInspectorElement.call(this, object);
};
lib_core.inherit(ValueUnitInspectorElement, TextInspectorElement);
lib_core.JsonParser.registerClass(ValueUnitInspectorElement, "ValueUnitInspectorElement");
ValueUnitInspectorElement.prototype.attributes = TextInspectorElement.prototype.attributes.concat(["unitmember", "allowed_units"]);

ValueUnitInspectorElement.prototype.combineWith = function(other) {
    this.unitmembers = [].concat(this.unitmembers || this.unitmember, other.unitmembers || other.unitmember);
    this.unitmember = null;

    var new_allowed_units = [];
    _.each(this.allowed_units, function(element) {
        _.each(other.allowed_units, function(other_element) {
            if(element == other_element) {
                new_allowed_units.push(element);
            }
        });
    });
    this.allowed_units = new_allowed_units;
    if(this.allowed_units.length == 0) return false;

    return TextInspectorElement.prototype.combineWith.call(this, other);
};

ValueUnitInspectorElement.prototype.finishCombination = function() {
    TextInspectorElement.prototype.finishCombination.call(this);
    if(this.times_combined == 1) return;
    this.unitmember = this.createValueSpreader("unitmember", this.unitmembers);
};


/*********************************** ValueUnitCheckInspectorElement ************************************/
/*
required fields:
checkmember
*/
var ValueUnitCheckInspectorElement = function(object) {
    ValueUnitInspectorElement.call(this, object);
};
lib_core.inherit(ValueUnitCheckInspectorElement, ValueUnitInspectorElement);
lib_core.JsonParser.registerClass(ValueUnitCheckInspectorElement, "ValueUnitCheckInspectorElement");
ValueUnitCheckInspectorElement.prototype.attributes = ValueUnitInspectorElement.prototype.attributes.concat(["checkmember"]);

ValueUnitCheckInspectorElement.prototype.combineWith = function(other) {
    this.checkmembers = [].concat(this.checkmembers || this.checkmember, other.checkmembers || other.checkmember);
    this.checkmember = null;
    return ValueUnitInspectorElement.prototype.combineWith.call(this, other);
};

ValueUnitCheckInspectorElement.prototype.finishCombination = function() {
    ValueUnitInspectorElement.prototype.finishCombination.call(this);
    if(this.times_combined == 1) return;
    this.checkmember = this.createValueSpreader("checkmember", this.checkmembers);
};


/*********************************** ValueFixedUnitInspectorElement ************************************/
/*
required fields:
unit
*/
var ValueFixedUnitInspectorElement = function(object) {
    TextInspectorElement.call(this, object);
};
lib_core.inherit(ValueFixedUnitInspectorElement, TextInspectorElement);
lib_core.JsonParser.registerClass(ValueFixedUnitInspectorElement, "ValueFixedUnitInspectorElement");
ValueFixedUnitInspectorElement.prototype.attributes = TextInspectorElement.prototype.attributes.concat([]); // "unit" OR "unitmember"

ValueFixedUnitInspectorElement.prototype.combineWith = function(other) {
    if(this.unit != other.unit) return false;
    return TextInspectorElement.prototype.combineWith.call(this, other);
};

/*********************************** AbstractSelectBoxInspectorElement ************************************/

var AbstractSelectBoxInspectorElement = function(object) {
    var self = this;
    object.list_ = object.list; //delete object.list; //prevent overwriting this.list
    AbstractInspectorElement.call(this, object);

    if(this.list_.getType && this.list_.getType() == "value")    //convert into value
        this.unprocessed_list = this.list_;
    else {
        this.unprocessed_list = this.value("list", true); // TODO: why isn't this a observable list?
        this.unprocessed_list(this.list_);
    }

    console.assert(this.unprocessed_list() instanceof Array);

    this.processed_list = this.value("processed_list", true);  //convert into label/value pairs
    function processList() {
        self.processed_list(self.unprocessed_list().map(function(pair){
            var label = pair.constructor == Array ? pair[0] : pair;
            var value = pair.constructor == Array ? pair[1] : label;
            return {'name': label, 'value': value};
        }));
    }
    this.unprocessed_list.onChange(this, processList);
    processList();
    this.list_ = this.processed_list;
};
lib_core.inherit(AbstractSelectBoxInspectorElement, AbstractInspectorElement);
lib_core.JsonParser.registerClass(AbstractSelectBoxInspectorElement, "AbstractSelectBoxInspectorElement");

/*********************************** SelectBoxInspectorElement ************************************/
/*
required fields:
list of options
*/
var SelectBoxInspectorElement = function(object) {
    AbstractSelectBoxInspectorElement.call(this, object);
};

lib_core.inherit(SelectBoxInspectorElement, AbstractSelectBoxInspectorElement);
lib_core.JsonParser.registerClass(SelectBoxInspectorElement, "SelectBoxInspectorElement");
SelectBoxInspectorElement.prototype.attributes = AbstractSelectBoxInspectorElement.prototype.attributes.concat(["list_"]);

SelectBoxInspectorElement.extractCommonOptions = function(list, other_list) {
    var new_list = [];
    _.each(list, function(element) {
        _.each(other_list, function(other_element) {
            if(element.name == other_element.name && element.label == other_element.label) {
                new_list.push(element);
            }
        });
    });
    return new_list;
};

SelectBoxInspectorElement.prototype.combineWith = function(other) {
    if(!other.list_) return false;
    var new_list = SelectBoxInspectorElement.extractCommonOptions(this.list_(), other.list_());
    if(new_list.length == 0) return false;
    this.list_(new_list);
    return AbstractSelectBoxInspectorElement.prototype.combineWith.call(this, other);
};

SelectBoxInspectorElement.prototype.finishCombination = function() {
    AbstractSelectBoxInspectorElement.prototype.finishCombination.call(this);
};

/*********************************** SelectBoxEventInspectorElement ************************************/
/*
required fields:
initial value
list of options
*/
var SelectBoxEventInspectorElement = function(object) {
    AbstractSelectBoxInspectorElement.call(this, object);
};

lib_core.inherit(SelectBoxEventInspectorElement, AbstractSelectBoxInspectorElement);
lib_core.JsonParser.registerClass(SelectBoxEventInspectorElement, "SelectBoxEventInspectorElement");
SelectBoxEventInspectorElement.prototype.attributes = AbstractInspectorElement.prototype.attributes.concat(["list_", "init", "cEvent"]);

SelectBoxEventInspectorElement.prototype.combineWith = function(other) {
    if(this.init !== other.init) this.init = "";
    this.lists_ = [].concat(this.lists_ || this.list_, other.lists_ || other.list_);
    this.list_ = null;
    this.cEvents = [].concat(this.cEvent || this.cEvents, other.cEvent || other.cEvents);
    this.cEvent = null;
    return AbstractSelectBoxInspectorElement.prototype.combineWith.call(this, other);
};

SelectBoxEventInspectorElement.prototype.finishCombination = function() {
    var self = this;
    AbstractSelectBoxInspectorElement.prototype.finishCombination.call(this);
    if(this.times_combined == 1) return;

    console.assert(this.lists_);
    var triggers = [];
    _.each(this.lists_, function(l) {
        triggers.push([l, l.onChange]);
    });
    var list_spreader = self.shadow("list_spreader",
        function() {
            var list = self.lists_[0]();
            _.each(self.lists_, function(l) {
                list = SelectBoxInspectorElement.extractCommonOptions(list, l());
            });
            return list;
        },
        null,
        triggers
    );
    this.list_ = list_spreader;
    this.cEvent = this.cEvents;
};

/*********************************** SliderInspectorElement ************************************/
/*
required fields:
list of options
*/
var SliderInspectorElement = function(object) {
    TextInspectorElement.call(this, object);
};
lib_core.inherit(SliderInspectorElement, TextInspectorElement);
lib_core.JsonParser.registerClass(SliderInspectorElement, "SliderInspectorElement");
SliderInspectorElement.prototype.attributes = SliderInspectorElement.prototype.attributes.concat(["sliderMin", "sliderMax", "sliderStep"]);

SliderInspectorElement.prototype.combineWith = function(other) {
    this.sliderMin = Math.max(this.sliderMin, other.sliderMin);
    this.sliderMax = Math.min(this.sliderMax, other.sliderMax);
    if(this.sliderMin >= this.sliderMax) return false;
    if(this.sliderStep != other.sliderStep) return false;
    return TextInspectorElement.prototype.combineWith.call(this, other);
};

SliderInspectorElement.prototype.finishCombination = function() {
    TextInspectorElement.prototype.finishCombination.call(this);
};


/*********************************** ButtonInspectorElement ************************************/
/*
required fields:
cEvent
*/
var ButtonInspectorElement = function(object) {
    AbstractInspectorElement.call(this, object);

    console.assert(object.icon !== undefined || object.label !== undefined, "button has no icon or label defined");
};
lib_core.inherit(ButtonInspectorElement, AbstractInspectorElement);
lib_core.JsonParser.registerClass(ButtonInspectorElement, "ButtonInspectorElement");
ButtonInspectorElement.prototype.attributes = ["cEvent"];

ButtonInspectorElement.prototype.combineWith = function(other) {
    this.cEvents = [].concat(this.cEvents || this.cEvent, other.cEvents || other.cEvent);
    this.cEvent = null;
    return AbstractInspectorElement.prototype.combineWith.call(this, other);
};

ButtonInspectorElement.prototype.finishCombination = function() {
    AbstractInspectorElement.prototype.finishCombination.call(this);
    if(this.times_combined == 1) return;
    this.cEvent = this.cEvents;
};


/*********************************** ButtonGroupInspectorElement ************************************/
/*
required fields:
buttons list with objects (label + cEvent)
*/
var ButtonGroupInspectorElement = function(object) {
    AbstractInspectorElement.call(this, object);
    this.buttons = _.map(this.buttons, function(button) {
        return new ButtonInspectorElement(button);
    });
};
lib_core.inherit(ButtonGroupInspectorElement, AbstractInspectorElement);
lib_core.JsonParser.registerClass(ButtonGroupInspectorElement, "ButtonGroupInspectorElement");
ButtonGroupInspectorElement.prototype.attributes = AbstractInspectorElement.prototype.attributes.concat(["buttons"]);

ButtonGroupInspectorElement.prototype.combineWith = function(other) {
    if(this.buttons.length != other.buttons.length) return false;
    var combined = true;
    _.each(this.buttons, function(button) {
        _.each(other.buttons, function(other_button) {
            if(button.label == other_button.label) {
                combined = combined && button.combineWith(other_button);
            }
        });
    });
    if(!combined) return false;
    return AbstractInspectorElement.prototype.combineWith.call(this, other);
};

ButtonGroupInspectorElement.prototype.finishCombination = function() {
    AbstractInspectorElement.prototype.finishCombination.call(this);
    _.each(this.buttons, function(button) {
        button.finishCombination();
    });
};



/*********************************** SpinnerInspectorElement ************************************/
/*
required fields:
*/
var SpinnerInspectorElement = function(object) {
    this.visible_if_any = true;
    AbstractInspectorElement.call(this, object);
};
lib_core.inherit(SpinnerInspectorElement, AbstractInspectorElement);
lib_core.JsonParser.registerClass(SpinnerInspectorElement, "SpinnerInspectorElement");
SpinnerInspectorElement.prototype.attributes = AbstractInspectorElement.prototype.attributes.concat([]);

/*********************************** LabelInspectorElement ************************************/
/*
required fields:
*/
var LabelInspectorElement = function(object) {
    AbstractInspectorElement.call(this, object);
};
lib_core.inherit(LabelInspectorElement, AbstractInspectorElement);
lib_core.JsonParser.registerClass(LabelInspectorElement, "LabelInspectorElement");

InspectorInputType.classes = {};
InspectorInputType.classes.AbstractInspectorElement = AbstractInspectorElement;
InspectorInputType.classes[InspectorInputType.IMAGE]                  = ImageInspectorElement;
InspectorInputType.classes[InspectorInputType.SELECTABLE_IMAGE_GROUP] = SelectableImageGroupInspectorElement;
InspectorInputType.classes[InspectorInputType.TEXT]                   = TextInspectorElement;
InspectorInputType.classes[InspectorInputType.READ_ONLY]              = AbstractInspectorElement;
InspectorInputType.classes[InspectorInputType.VALUE_AND_UNIT]         = ValueUnitInspectorElement;
InspectorInputType.classes[InspectorInputType.VALUE_UNIT_CHECK]       = ValueUnitCheckInspectorElement;
InspectorInputType.classes[InspectorInputType.VALUE_AND_FIXEDUNIT]    = ValueFixedUnitInspectorElement;
InspectorInputType.classes[InspectorInputType.CHECKBOX]               = TextInspectorElement;
InspectorInputType.classes[InspectorInputType.SELECTBOX]              = SelectBoxInspectorElement;
InspectorInputType.classes[InspectorInputType.SELECTBOXEVENT]         = SelectBoxEventInspectorElement;
InspectorInputType.classes[InspectorInputType.BUTTON]                 = ButtonInspectorElement;
InspectorInputType.classes[InspectorInputType.BUTTON_GROUP]           = ButtonGroupInspectorElement;
InspectorInputType.classes[InspectorInputType.SLIDER]                 = SliderInspectorElement;
InspectorInputType.classes[InspectorInputType.SPINNER]                = SpinnerInspectorElement;
InspectorInputType.classes[InspectorInputType.LABEL]                  = LabelInspectorElement;
InspectorInputType.classes[InspectorInputType.ROW]                    = RowInspectorElement;

InspectorInputType.convert = function(obj) {
    if(obj instanceof InspectorInputType.classes.AbstractInspectorElement)
        return obj;
    else
        return new InspectorInputType.classes[obj.type](obj);
};

module.exports = InspectorInputType;
